import { Typography, Row, Col } from "antd";
import React from "react";
import { connect } from "react-redux";
import { setPropsMath } from "../../../redux/actions/appActions";
import { Images, OddField, SpecialOddFieldButton } from "../..";
import {
  setEvent,
  getKironEvent,
} from "../../../redux/actions/sportEventsActions";
import { loadKironEvents } from "../../../redux/actions/sportEventsActions";
import { changeFeed } from "../../../redux/actions/appActions";
import { SpinAndWinEnums, Cookies, Enums, Utils } from "../../../helpers";
import ZoomModal from "./ZoomModal";
import NoActivityModal from "../NoActivityModal";
import moment from "moment";
import { useMediaQuery } from "react-responsive";

const IsMobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 550 });
  return isMobile ? children : null;
};
const IsTabletAndDesktop = ({ children }) => {
  const IsTabletAndDesktop = useMediaQuery({ minWidth: 550 });
  return IsTabletAndDesktop ? children : null;
};

const { Title } = Typography;

class EventsKiron extends React.Component {
  state = {
    selectedNumber: null,
    showZoomModal: false,
    row: null,
    column: null,
  };

  componentDidMount() {
    const { match, setPropsMath, getKironEvent } = this.props;
    setPropsMath(match);
    // to check if the browser is mock browser (user is opening from social media apps)
    // 
    if (this.props.connected) {
      let Data = {
        Feed: {
          FeedId: Number(match.params.feed),
        },
        Sport: {
          SportId: Number(match.params.sport),
        },

        EventId: parseInt(match.params.eventId),
      };
      getKironEvent({ Data });
    }
    this.SpinAnsWinTimeout();
    document.addEventListener("click", this.SpinAnsWinTimeout);
  }

  transformDate = (date) => {
    let newDate = moment(date, "hh:mm A DD/MM/YYYY");
    return newDate.format("DD/MM/YYYY HH:mm");
  };

  SpinAnsWinTimeout = () => {
    const tokenExpiresMinutes = Cookies.get("tokenExpiresMinutes");
    let time = (tokenExpiresMinutes || 5) * 60 * 1000;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      let noActivityModal = (
        <NoActivityModal
          text={`you will be redirected to the main page in`}
          time={30}
          onTimeoutFinished={() => {
            Utils.closeModal({ id: "spinAndWinTimeout" });
            this.navigate(
              `/sport/${Enums.Feed.Static}/1/Soccer`,
              Enums.Feed.Static,
              Enums.FeedNames.Static
            );
          }}
          okLabel="Cancel"
          onOK={() => {
            clearTimeout(this.timeout);
            Utils.closeModal({ id: "spinAndWinTimeout" });
          }}
        />
      );
      let modals = {
        key: "spinAndWinTimeout",
        type: "custom",
        children: noActivityModal,
        visible: true,
      };

      Utils.openModal(modals);
    }, time);
  };

  navigate = (
    route,
    feedId = Enums.Feed.Static,
    feedName = Enums.FeedNames.Static
  ) => {
    const { changeFeed, history } = this.props;
    history.push(`${route}`);
    changeFeed(feedId.toString(), feedName);
  };
  componentDidUpdate(prevProps) {
    const { match, getKironEvent, setPropsMath } = this.props;
    if (
      (!prevProps.connected && this.props.connected) ||
      prevProps.match.params.eventId !== match.params.eventId ||
      (prevProps.eventData && !this.props.eventData)
    ) {
      let Data = {
        Feed: {
          FeedId: Number(match.params.feed),
        },
        Sport: {
          SportId: Number(match.params.sport),
        },

        EventId: parseInt(match.params.eventId),
      };
      setPropsMath(match);

      getKironEvent({ Data });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.SpinAnsWinTimeout);
    clearTimeout(this.timeout);
  }

  hideZoomModal = () => {
    this.setState({
      selectedNumber: null,
      showZoomModal: false,
      row: null,
      column: null,
    });
  };

  onNumberClick = (rowIndex, colIndex, selectedNumber) => {
    let row = rowIndex;
    let column = colIndex;
    this.setState({
      showZoomModal: true,
      row,
      column,
      selectedNumber,
    });
  };

  colRenderer = (rows, rowIndex) => {
    let col = [];
    rows.map((num, colIndex) =>
      col.push(
        <div
          key={num}
          onClick={() => {
            this.onNumberClick(rowIndex, colIndex, num);
          }}
          className={`cols col-${num}`}
          span={2}
        >
          {<OddField key={colIndex} number={num} />}
          <div style={{display:"flex" , justifyContent:"center" , alignItems:"center"}}><span>{num}</span></div>
        </div>
      )
    );
    return col;
  };

  rowRenderer = () => {
    let board = [];
    for (let i = 0; i < SpinAndWinEnums.boardRows.length; i++) {
      board.push(
        <div key={i} className={`rows row-${i + 1}`}>
          {this.colRenderer(SpinAndWinEnums.boardRows[i], i)}
        </div>
      );
    }
    return board;
  };
  render() {
    const {
      match,
      loadingKironEvents,
      title,
      eventsIds,
      error,
      eventOddFields,
      eventData,
      ActiveSpinAndWinTables,
      isWheelLoading
    } = this.props;
    return (
      <div>
        {error && <div>{error}</div>}

        {loadingKironEvents &&  !isWheelLoading && (
          <div className="events">
            {/* <div className="skeleton">
							<div className="row">
								<div className="loader"></div>
								<div className="col"></div>
								<div className="col"></div>
								<div className="col"></div>
								<div className="col"></div>
							</div>

							<div className="row">
								<div className="loader"></div>
								<div className="col"></div>
								<div className="col"></div>
								<div className="col"></div>
								<div className="col"></div>
							</div>

							<div className="row">
								<div className="loader"></div>
								<div className="col"></div>
								<div className="col"></div>
								<div className="col"></div>
								<div className="col"></div>
							</div>
						</div> */}
            <div className="lds-parent-ring">
              <div class="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
          </div>
        )}

        {eventOddFields !== undefined &&
          Object.keys(eventOddFields).length > 0 &&
          !loadingKironEvents &&
          eventData && (
            <div style={{ position: "relative" }}>
              {!eventData.enableBet && (
                <Title level={2} className="game-not-available-txt">
                  Game is no longer available for betting
                </Title>
              )}
                  <IsMobile>
                  <img alt="rotate-icon" src={Images.RotateIcon} className="rotate-icon-SW"/>
                  </IsMobile>
<IsTabletAndDesktop>
              <div
                className={`SW-container ${
                  eventData && !eventData.enableBet ? "disabled" : ""
                }`}
              >
                {eventData && (
                  <div className="snw-header">
                    <div
                      style={{
                        fontSize: 24,
                        fontWeight: "bold",
                        marginBottom: 0,
                        lineHeight: 1,
                      }}
                    >
                      {eventData.kironEventNumber} - {eventData.eventBetLineNo}
                    </div>
                    <div style={{ opacity: 0.6, fontSize: 16 }}>
                      {this.transformDate(eventData.eventDateOfMatchFormated)}
                    </div>
                    <div className="break-line" />
                  </div>
                )}
                <div className="game-board">
                  <div className="col0-container">
                    <div
                      className="col-0"
                      onClick={() => this.onNumberClick(null, null, 0)}
                    >
                      {<OddField number={0} />}
                      <span>0</span>
                    </div>
                  </div>
                  <div className="board-center-btns">
                    {this.rowRenderer()}

                    {this.state.showZoomModal && (
                      <ZoomModal
                        row={this.state.row}
                        column={this.state.column}
                        selectedNumber={this.state.selectedNumber}
                        hideZoomModal={this.hideZoomModal}
                      />
                    )}
                  </div>

                  <div className="columns">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds)
                        .map((item, i) => {
                          if (
                            item.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.columns
                          ) {
                            let field = Object.values(odds)[i];
                            return (
                              <SpecialOddFieldButton
                                key={i}
                                text={"2 to 1"}
                                oddFieldId={field.activeOddFieldId}
                                field={field}
                              />
                            );
                          }
                        })
                        .sort((a, b) => b.key - a.key)
                    )}
                  </div>
                </div>
                <div className="options-container">
                  <div className="dozens">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.dozens
                        ) {
                          let field = Object.values(odds)[i];
                          return (
                            <SpecialOddFieldButton
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                  </div>

                  <div className="optionsBar">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.hightLow
                        ) {
                          let field = Object.values(odds)[i];
                          return (
                            <SpecialOddFieldButton
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds)
                        .map((item, i) => {
                          if (
                            item.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.colors
                          ) {
                            let field = Object.values(odds)[i];
                            return (
                              field.oddField !== "Green" && (
                                <SpecialOddFieldButton
                                  className={`color-shape-${
                                    field.oddFieldDisplayName
                                  }`}
                                  key={i}
                                  text={null}
                                  oddFieldId={field.activeOddFieldId}
                                  field={field}
                                />
                              )
                            );
                          }
                        })
                        .reverse()
                    )}

                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.oddEven
                        ) {
                          let field = Object.values(odds)[i];
                          return (
                            <SpecialOddFieldButton
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                  </div>

                  <div className="sectors">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.sectors
                        ) {
                          let field = Object.values(odds)[i];
                          let background = SpinAndWinEnums.sectors.find(
                            (sector) =>
                              sector.text === field.oddFieldDisplayName
                          ).color;
                          return (
                            <SpecialOddFieldButton
                              style={{
                                borderBottom: `5px solid ${background}`,
                                letterSpacing: 1.5,
                                width: 170,
                                margin: "6px 0px 1px 0",
                              }}
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                  </div>
                </div>

                <div className="neighbors">
                  {Object.values(eventOddFields).map((odds) =>
                    Object.values(odds).map((field, i) => {
                      if (
                        field.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.neighbors &&
                        SpinAndWinEnums.neighbors[0].value === field.oddField
                      ) {
                        return (
                          <div className="col-0" key={i}>
                            <SpecialOddFieldButton
                              key={i}
                              text={SpinAndWinEnums.neighbors[0].text}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          </div>
                        );
                      }
                    })
                  )}
                  <div>
                    <div className="row" style={{ padding: 0 }}>
                      {SpinAndWinEnums.neighbors[1].map((neighbor) => {
                        return Object.values(eventOddFields).map((odds) =>
                          Object.values(odds).map((field, i) => {
                            if (
                              field.betType.betTypeId ===
                                SpinAndWinEnums.betTypes.neighbors &&
                              neighbor.value === field.oddField &&
                              neighbor.text !== "0"
                            ) {
                              return (
                                <SpecialOddFieldButton
                                  containerStyle={{
                                    background: neighbor.color,
                                  }}
                                  key={i}
                                  text={neighbor.text}
                                  oddFieldId={field.activeOddFieldId}
                                  field={field}
                                />
                              );
                            }
                          })
                        );
                      })}
                    </div>
                    <Title className="neighbors-title" level={4}>
                      Neighbours{" "}
                    </Title>
                    <div
                      className="break-line"
                      style={{ margin: "0 0 41px 0" }}
                    />
                    <div className="row" style={{ padding: 0 }}>
                      {SpinAndWinEnums.neighbors[2].map((neighbor) => {
                        return Object.values(eventOddFields).map((odds) =>
                          Object.values(odds).map((field, i) => {
                            if (
                              field.betType.betTypeId ===
                                SpinAndWinEnums.betTypes.neighbors &&
                              neighbor.value === field.oddField &&
                              neighbor.text !== "0"
                            ) {
                              return (
                                <SpecialOddFieldButton
                                  containerStyle={{
                                    background: neighbor.color,
                                  }}
                                  key={i}
                                  text={neighbor.text}
                                  oddFieldId={field.activeOddFieldId}
                                  field={field}
                                />
                              );
                            }
                          })
                        );
                      })}
                    </div>
                  </div>

                  <div style={{ position: "relative" }}>
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((field, i) => {
                        if (
                          field.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.neighbors &&
                          SpinAndWinEnums.neighbors[3].value === field.oddField
                        ) {
                          return (
                            <div className="col-10" key={i}>
                              <SpecialOddFieldButton
                                key={i}
                                text={SpinAndWinEnums.neighbors[3].text}
                                oddFieldId={field.activeOddFieldId}
                                field={field}
                              />
                            </div>
                          );
                        }
                      })
                    )}
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((field, i) => {
                        if (
                          field.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.neighbors &&
                          SpinAndWinEnums.neighbors[4].value === field.oddField
                        ) {
                          return (
                            <div className="col-5" key={i}>
                              <SpecialOddFieldButton
                                key={i}
                                text={SpinAndWinEnums.neighbors[4].text}
                                oddFieldId={field.activeOddFieldId}
                                field={field}
                              />
                            </div>
                          );
                        }
                      })
                    )}
                  </div>
                </div>
                <div className="outline" style={{ top: 20 }}>
                  {" "}
                </div>
                <div className="outline" style={{ top: 20, right: 0 }}>
                  {" "}
                </div>
                <div className="outline" style={{ right: 0, bottom: 20 }}>
                  {" "}
                </div>
                <div className="outline" style={{ bottom: 20 }}>
                  {" "}
                </div>
              </div>
              </IsTabletAndDesktop>
<IsMobile>
              <div
                className={`SW-container disabled`}
              >
                {eventData && (
                  <div className="snw-header">
                    <div
                      style={{
                        fontSize: 24,
                        fontWeight: "bold",
                        marginBottom: 0,
                        lineHeight: 1,
                      }}
                    >
                      {eventData.kironEventNumber} - {eventData.eventBetLineNo}
                    </div>
                    <div style={{ opacity: 0.6, fontSize: 16 }}>
                      {this.transformDate(eventData.eventDateOfMatchFormated)}
                    </div>
                    <div className="break-line" />
                  </div>
                )}
                <div className="game-board">
                  <div className="col0-container">
                    <div
                      className="col-0"
                      onClick={() => this.onNumberClick(null, null, 0)}
                    >
                      {<OddField number={0} />}
                      <span>0</span>
                    </div>
                  </div>
                  <div className="board-center-btns">
                    {this.rowRenderer()}

                    {this.state.showZoomModal && (
                      <ZoomModal
                        row={this.state.row}
                        column={this.state.column}
                        selectedNumber={this.state.selectedNumber}
                        hideZoomModal={this.hideZoomModal}
                      />
                    )}
                  </div>

                  <div className="columns">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds)
                        .map((item, i) => {
                          if (
                            item.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.columns
                          ) {
                            let field = Object.values(odds)[i];
                            return (
                              <SpecialOddFieldButton
                                key={i}
                                text={"2 to 1"}
                                oddFieldId={field.activeOddFieldId}
                                field={field}
                              />
                            );
                          }
                        })
                        .sort((a, b) => b.key - a.key)
                    )}
                  </div>
                </div>
                <div className="options-container">
                  <div className="dozens">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.dozens
                        ) {
                          let field = Object.values(odds)[i];
                          return (
                            <SpecialOddFieldButton
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                  </div>

                  <div className="optionsBar">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.hightLow
                        ) {
                          let field = Object.values(odds)[i];
                          return (
                            <SpecialOddFieldButton
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds)
                        .map((item, i) => {
                          if (
                            item.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.colors
                          ) {
                            let field = Object.values(odds)[i];
                            return (
                              field.oddField !== "Green" && (
                                <SpecialOddFieldButton
                                  className={`color-shape-${
                                    field.oddFieldDisplayName
                                  }`}
                                  key={i}
                                  text={null}
                                  oddFieldId={field.activeOddFieldId}
                                  field={field}
                                />
                              )
                            );
                          }
                        })
                        .reverse()
                    )}

                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.oddEven
                        ) {
                          let field = Object.values(odds)[i];
                          return (
                            <SpecialOddFieldButton
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                  </div>

                  <div className="sectors">
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((item, i) => {
                        if (
                          item.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.sectors
                        ) {
                          let field = Object.values(odds)[i];
                          let background = SpinAndWinEnums.sectors.find(
                            (sector) =>
                              sector.text === field.oddFieldDisplayName
                          ).color;
                          return (
                            <SpecialOddFieldButton
                              style={{
                                borderBottom: `5px solid ${background}`,
                                letterSpacing: 1.5,
                                width: 170,
                                margin: "6px 0px 1px 0",
                              }}
                              key={i}
                              text={field.oddFieldDisplayName}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          );
                        }
                      })
                    )}
                  </div>
                </div>

                <div className="neighbors">
                  {Object.values(eventOddFields).map((odds) =>
                    Object.values(odds).map((field, i) => {
                      if (
                        field.betType.betTypeId ===
                          SpinAndWinEnums.betTypes.neighbors &&
                        SpinAndWinEnums.neighbors[0].value === field.oddField
                      ) {
                        return (
                          <div className="col-0" key={i}>
                            <SpecialOddFieldButton
                              key={i}
                              text={SpinAndWinEnums.neighbors[0].text}
                              oddFieldId={field.activeOddFieldId}
                              field={field}
                            />
                          </div>
                        );
                      }
                    })
                  )}
                  <div>
                    <div className="row" style={{ padding: 0 }}>
                      {SpinAndWinEnums.neighbors[1].map((neighbor) => {
                        return Object.values(eventOddFields).map((odds) =>
                          Object.values(odds).map((field, i) => {
                            if (
                              field.betType.betTypeId ===
                                SpinAndWinEnums.betTypes.neighbors &&
                              neighbor.value === field.oddField &&
                              neighbor.text !== "0"
                            ) {
                              return (
                                <SpecialOddFieldButton
                                  containerStyle={{
                                    background: neighbor.color,
                                  }}
                                  key={i}
                                  text={neighbor.text}
                                  oddFieldId={field.activeOddFieldId}
                                  field={field}
                                />
                              );
                            }
                          })
                        );
                      })}
                    </div>
                    <Title className="neighbors-title" level={4}>
                      Neighbours{" "}
                    </Title>
                    <div
                      className="break-line"
                      style={{ margin: "0 0 41px 0" }}
                    />
                    <div className="row" style={{ padding: 0 }}>
                      {SpinAndWinEnums.neighbors[2].map((neighbor) => {
                        return Object.values(eventOddFields).map((odds) =>
                          Object.values(odds).map((field, i) => {
                            if (
                              field.betType.betTypeId ===
                                SpinAndWinEnums.betTypes.neighbors &&
                              neighbor.value === field.oddField &&
                              neighbor.text !== "0"
                            ) {
                              return (
                                <SpecialOddFieldButton
                                  containerStyle={{
                                    background: neighbor.color,
                                  }}
                                  key={i}
                                  text={neighbor.text}
                                  oddFieldId={field.activeOddFieldId}
                                  field={field}
                                />
                              );
                            }
                          })
                        );
                      })}
                    </div>
                  </div>

                  <div style={{ position: "relative" }}>
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((field, i) => {
                        if (
                          field.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.neighbors &&
                          SpinAndWinEnums.neighbors[3].value === field.oddField
                        ) {
                          return (
                            <div className="col-10" key={i}>
                              <SpecialOddFieldButton
                                key={i}
                                text={SpinAndWinEnums.neighbors[3].text}
                                oddFieldId={field.activeOddFieldId}
                                field={field}
                              />
                            </div>
                          );
                        }
                      })
                    )}
                    {Object.values(eventOddFields).map((odds) =>
                      Object.values(odds).map((field, i) => {
                        if (
                          field.betType.betTypeId ===
                            SpinAndWinEnums.betTypes.neighbors &&
                          SpinAndWinEnums.neighbors[4].value === field.oddField
                        ) {
                          return (
                            <div className="col-5" key={i}>
                              <SpecialOddFieldButton
                                key={i}
                                text={SpinAndWinEnums.neighbors[4].text}
                                oddFieldId={field.activeOddFieldId}
                                field={field}
                              />
                            </div>
                          );
                        }
                      })
                    )}
                  </div>
                </div>
                <div className="outline" style={{ top: 20 }}>
                  {" "}
                </div>
                <div className="outline" style={{ top: 20, right: 0 }}>
                  {" "}
                </div>
                <div className="outline" style={{ right: 0, bottom: 20 }}>
                  {" "}
                </div>
                <div className="outline" style={{ bottom: 20 }}>
                  {" "}
                </div>
              </div>
              </IsMobile>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    loadingKironEvents: state.virtual.loadingKironEvents,
    eventsIds: state.sportEvents.eventsIds,
    error: state.sportEvents.error,
    connected: state.signalr.spinAndWinConnected,
    sportData: state.sportTypes.sportData,
    eventOdds: state.sportEvents.eventOdds,
    eventOddFields: state.sportEvents.eventOddFields,
    eventData: state.sportEvents.eventData,
    barItems: state.virtual.barItems,
    ActiveSpinAndWinTables: state.general.ActiveSpinAndWinTables,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadKironEvents: (data) => {
      dispatch(loadKironEvents(data));
    },
    setEvent: (item) => {
      dispatch(setEvent(item));
    },
    setPropsMath: (match) => {
      dispatch(setPropsMath(match));
    },
    getKironEvent: (request) => {
      dispatch(getKironEvent(request));
    },
    changeFeed: (feedId, feedName) => dispatch(changeFeed(feedId, feedName)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsKiron);
